// Dev-only auth bypass. Lets the agent screenshot authenticated pages without a real Auth0 session.
//
// Enable by setting VITE_DEV_BYPASS_AUTH=true in .env.development.local. The flag is gated on
// import.meta.env.DEV, so in a prod build it is `false` and every call site below folds away. The mocked
// backend itself (fixtures included) is src/dev/mockFetch.ts, loaded with `import()` on the first call —
// nothing of it is in a bundle built without the bypass.

export const devBypassEnabled = import.meta.env.DEV && import.meta.env.VITE_DEV_BYPASS_AUTH === 'true'

// Optional: run the REAL web-billing widget under the bypass. Set
// VITE_DEV_BYPASS_BILLING_CUSTOMER_ID (in .env.development.local) to a customer_id with a
// live signup session on the dev engine — e.g. one minted through med-web-funnel's stand
// with ?mock-data. The billing change endpoints are anonymous, so with a valid id the
// widget's POST /v1/client-session succeeds and /payment/update renders the real
// Stripe-hosted form instead of the static lookalikes.
export const devBypassBillingCustomerId: string | undefined =
	(devBypassEnabled && import.meta.env.VITE_DEV_BYPASS_BILLING_CUSTOMER_ID) || undefined

export const devMockUser = {
	sub: 'auth0|dev-stub',
	email: 'dev@stub.local',
	// Mirror Auth0: for accounts without a profile name, the `name` claim defaults to the
	// email. The real name comes from med-users (the /auth/login mock in src/dev/mockFetch.ts).
	name: 'dev@stub.local',
}

/** The bypass's backend: every authed call answers from src/dev/mockFetch.ts, loaded on the first one. */
export async function devMockFetch(url: string, init?: RequestInit): Promise<Response> {
	const { mockFetch } = await import('@/dev/mockFetch')
	return mockFetch(url, init)
}
